import React, { Component } from "react";
import "./CustomTooltip.css";


export default class CustomTooltip extends Component {
  /*
  getReactContainerClasses() {
    return ["custom-tooltip"];
  }
*/
  render() {
    return (
      <div className="custom-tooltip">
        <p>{this.props.value}</p>
      </div>
    );
  }
}
